<!--
 * @Author: chen cs
 * @Date: 2020-03-09 19:41:27
 * @LastEditors: chen cs
 * @LastEditTime: 2020-03-09 19:42:59
 * @Description: file content
 -->
<template>
  <!-- 隐私协议与用户协议 author: zhangxiaofeng -->
  <div id="privacy">
    <div class="privacy-bg" style="display: block;">
      <div class="privacy-box">
        <h3>
          隐私协议与用户协议
          <a class="w-icon-guanbi" @click="close()"></a>
        </h3>
        <div class="privacy-body">
          <div class="privacy-tabs">
            <!--  privacy-bg-white -->
            <span v-for="(tab, idx) in tabs"
                  :class="['privacy-tab privacy-tab' + (idx + 1), idx + 1 === showContent ? 'privacy-bg-white' : '']"
                  @click="showContent = idx + 1"
                  :key="idx">
              {{tab}}
            </span>
          </div>
          <div class="privacy-content" style="height: 424px;">
            <user-agreement v-show="showContent === 1"></user-agreement>
            <privacy-protocol v-show="showContent === 2"></privacy-protocol>
          </div>
          <div class="privacy-accept">
            <a class="privacy-btn" @click="agreeAll">
              已阅读并同意
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  @import "Index";
</style>
<script>
import UserAgreement from './UserAgreement'
import PrivacyProtocol from './PrivacyProtocol'
import { getCookie } from '@/assets/utils/CommonUtil'
import service from '@/assets/service'
export default {
  name: 'privacy',
  data () {
    return {
      // isAgree: true,
      tabs: ['用户协议', '隐私协议'],
      showContent: 1
    }
  },
  mounted () {},
  methods: {
    agreeAll () {
      // 添加用户账号
      ga('set', 'userId', getCookie('ZJYACCOUNT'))

      this.close(true)
    },
    close (agree) {
      if (!agree) {
        // 设置埋点userId为gldID
        const zjyUserInfo = JSON.parse(getCookie('ZJYUSERINFO'))
        if (zjyUserInfo && zjyUserInfo.gldUserId) {
          ga('set', 'userId', zjyUserInfo.gldUserId)
        }
      }
      this.onInstanceClose(this.boxId)
      this.isShow = false
      const type = agree ? 1 : 0
      if (type) {
        // 设置 隐私协议 已阅读并同意
        service.user.setPrivacy({type}).then((data) => {
          // if (!agree){
          //   // 没同意隐私协议
          //   this.isAgree = false
          // }
        })
      }
    }
  },
  components: {
    UserAgreement,
    PrivacyProtocol
  }
}
</script>
